<!--一体化教研-->
<template>
    <div class="container">
        <div class="wel-box">
            <div class="top-box">
                <homeHead ref="homeHead" />
            </div>
            <div class="course-container">
                <div class="left-menu-container">
                    <edu-research-menu :item-num="this.activeItem"
                                 @change-item="changeItem"/>
                </div>
                <!--个人备课-->
                <div v-if="activeItem==='2'"  class="right-content-container">
                    <edu-user-lesson :course-mode="this.activeMode"
                                     @change-mode="changeMode"/>
                </div>
                <!--协同备课-->
                <div v-if="activeItem==='3'"  class="right-content-container">
                    <edu-team-lesson :course-mode="this.activeMode"
                                     @change-mode="changeMode"/>
                </div>
                <!--已发布备课-->
                <div v-if="activeItem==='4'"  class="right-content-container">
                    <edu-release-lesson :course-mode="this.activeMode"
                                     @change-mode="changeMode"/>
                </div>
                <!--听评课-->
                <div v-if="activeItem==='5'"  class="right-content-container">
                    <edu-eva-lesson :course-mode="this.activeMode"
                                        @change-mode="changeMode"/>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import homeHead from "@/components/homeHead.vue";
import homeFooter from "@/components/homeFooter";
import dataEmpty from "@/components/dataEmpty.vue";
import eduResearchMenu from "@/components/eduResearch/eduResearchMenu.vue";
import eduResearchStat from "@/components/eduResearch/eduResearchStat.vue";
import eduUserLesson from "@/components/eduResearch/eduUserLesson.vue";
import eduTeamLesson from "@/components/eduResearch/eduTeamLesson.vue";
import eduReleaseLesson from "@/components/eduResearch/eduReleaseLesson.vue";
import eduEvaLesson from "@/components/eduResearch/eduEvaLesson.vue";
import pageCourse from "@/components/resourceCentre/pageCourse.vue";
export default {
    components: {
        pageCourse,
        eduResearchMenu,
        dataEmpty,
        homeHead,
        homeFooter,
        eduResearchStat,
        eduUserLesson,
        eduTeamLesson,
        eduReleaseLesson,
        eduEvaLesson
    },
    name: "homeEduResearch",
    data() {
        return {
            pageMode:"page",
            detailMode:"detail",
            timestampToTime,
            activePath: "homeEduResearch",
            activeItem:"2",
            activeMode:"page",
        }
    },
    computed: {},
    watch: {},
    created() {
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
    },
    methods: {
        changeItem(item){
            if (item==='6'){
                window.open('https://orgzuoye.slilm.com/', '_blank')
                return;
            }
            this.activeItem = item;
            this.activeMode = this.pageMode;

        },
        changeMode(mode){
            this.activeMode = mode;
        }
    }
}
</script>
<style scoped>
.container {
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: auto!important;
    overflow-x: hidden;
    background-color: #f1f1f1;
}
.wel-box {
    width:100vw;
    height: auto;
    overflow-y: auto!important;
    .top-box{
        display: flex;
        width: 100vw;
        height: 70px;
        background: #0d55a4;
    }
}
.course-container{
    width: 100%;
    height: auto;
    border: 10px;
    box-sizing: border-box;
    display: flex;
}
.left-menu-container{
    width: 200px;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
.right-content-container{
    width: calc(100% - 200px);
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
</style>